import React from "react";
import theme from "theme";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import store from "redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import {
  BrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import TagManager from "react-gtm-module";
import { Provider } from "react-redux";

TagManager.initialize({
  gtmId: "GTM-5LW4ZS4",
});

export const handleLocalStorage = (rootElement: HTMLElement | null) => {
  const savedBundleHash = window.localStorage.getItem("bundleHash");
  const currentBundleHash = rootElement?.dataset.hash?.split(".")[1] || "";

  if (savedBundleHash !== currentBundleHash) {
    window.localStorage.clear();
  }
  window.localStorage.setItem("bundleHash", currentBundleHash);
};

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement as HTMLDivElement);

handleLocalStorage(rootElement);

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <PersistGate loading={null} persistor={persistStore(store)}>
          <App />
        </PersistGate>
      </BrowserRouter>
    </ThemeProvider>
  </Provider>,
);
